import { ICON_NAME_WI_FI } from 'app/design-system/constants/IconNames';
import { IconName } from 'app/design-system/types/Icon';

import { SERVICE_MENU_ICON_NAME, SERVICE_MENU_LIST_KEY } from './constants';

export const getServiceIconName = (key: string): IconName => {
  const iconMap : Record<string, IconName> = {
    [SERVICE_MENU_LIST_KEY.PERSONAL_DATA]: SERVICE_MENU_ICON_NAME.PERSONAL_DATA,
    [SERVICE_MENU_LIST_KEY.GIFTS]: SERVICE_MENU_ICON_NAME.GIFTS,
    [SERVICE_MENU_LIST_KEY.DEPOSIT]: SERVICE_MENU_ICON_NAME.DEPOSIT,
    [SERVICE_MENU_LIST_KEY.WITHDRAWAL]: SERVICE_MENU_ICON_NAME.WITHDRAWAL,
    [SERVICE_MENU_LIST_KEY.ACTIVE_STAKES]: SERVICE_MENU_ICON_NAME.ACTIVE_STAKES,
    [SERVICE_MENU_LIST_KEY.BET_HISTORY]: SERVICE_MENU_ICON_NAME.BET_HISTORY,
    [SERVICE_MENU_LIST_KEY.REFERRAL]: SERVICE_MENU_ICON_NAME.REFERRAL,
    [SERVICE_MENU_LIST_KEY.NOTIFICATIONS]: SERVICE_MENU_ICON_NAME.NOTIFICATIONS,
    [SERVICE_MENU_LIST_KEY.CASHBACK]: SERVICE_MENU_ICON_NAME.CASHBACK,
    [SERVICE_MENU_LIST_KEY.PREFERENCES]: SERVICE_MENU_ICON_NAME.PREFERENCES,
  };

  return iconMap[key] || ICON_NAME_WI_FI;
};
